'use client';

import { QRCodeSVG } from 'qrcode.react';
import styles from './checkInQRCode.module.scss';

type CheckInQRCodeProps = {
  attendanceId: string;
  eventId: string;
};

export default function CheckInQRCode({
  attendanceId,
  eventId
}: CheckInQRCodeProps) {
  const origin =
    typeof window === 'undefined'
      ? (process.env.NEXT_PUBLIC_VOLUNTEER_URL ?? '')
      : window.location.origin;

  const checkinUrl = `${origin}/partner/dashboard/events/${eventId}/checkin?attendanceId=${attendanceId}`;

  if (!origin) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Event Check-In</h3>
      <p className={styles.description}>
        Show this QR code to the event organizer to check in.
      </p>
      <div className={styles.qrWrapper}>
        <QRCodeSVG value={checkinUrl} size={180} level="M" marginSize={2} />
      </div>
    </div>
  );
}
